module.exports = __webpack_public_path__ + "static/media/arrow-down-large-dec.43322683.svg";